"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactComponent = SvgComponent;
exports.default = void 0;

var _pragma = require("../../pragma");

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgComponent(props) {
  return (0, _pragma.createFelaElement)("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), (0, _pragma.createFelaElement)("defs", null), (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.989 5c2.225 0 4.37.665 6.374 1.977C20.117 8.126 21.79 10.1 23 12c-1.205 1.917-2.873 3.894-4.626 5.04-1.992 1.3-4.14 1.96-6.385 1.96-2.266 0-4.417-.66-6.396-1.96C3.867 15.903 2.21 13.924 1 12c1.497-2.144 3.324-4.19 5.187-5.316C8.035 5.569 9.987 5 11.989 5zM9.555 15.492A4.55 4.55 0 0012 16.2a4.514 4.514 0 003.11-1.232A4.11 4.11 0 0016.4 12a4.06 4.06 0 00-.742-2.333 4.363 4.363 0 00-1.974-1.547c-.804-.318-1.689-.401-2.542-.24s-1.638.563-2.253 1.15-1.035 1.336-1.204 2.15c-.17.815-.083 1.66.25 2.427a4.249 4.249 0 001.62 1.885zM15 12a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }));
}

var _default = 'src/asset/icon/eye-on.icon.svg';
exports.default = _default;
//# sourceMappingURL=eye-on.icon.js.map